<template>
  <div class="container px-0 mb-2" id="settings-management">
    <CardRoot class="border-translucent">
      <CardHeader>
        <CardTitle>{{ $t("settings.title") }}</CardTitle>
      </CardHeader>
      <CardBody class="pt-0">
        <TabsContainer
          :tabs="tabs"
          @change:tab="setTab"
          :activeTab="activeTab || 'settings'"
        >
          <template #tab-settings>
            <SettingsComponent
              v-if="company && company.id"
              :companyId="company.id"
              :company="company"
            />
          </template>
          <template #tab-devices>
            <RegistryDevicesSection v-if="company" :company="company" />
          </template>
        </TabsContainer>
      </CardBody>
    </CardRoot>
  </div>
</template>

<script setup lang="ts">
import {
  CardBody,
  CardHeader,
  CardRoot,
  CardTitle,
} from "@/components/common/card";
import TabsContainer from "@/components/common/tabs/TabsContainer.vue";
import { useTabs } from "@/composables/useTabs";
import RegistryDevicesSection from "@/dashboard/production_strategy/RegistryDevicesSection.vue";
import SettingsComponent from "@/dashboard/settings_management/SettingsComponent.vue";
import { IS_PRODUCER_VIEW } from "@/constants";
import type { Company } from "@/types";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  company?: Company;
}>();

const { t } = useI18n();

const tabs = computed(() => {
  const allTabs = [
    {
      id: "settings",
      name: t("settings.title"),
      icon: "cog",
      disabled: false,
    },
    {
      id: "devices",
      name: t("dashboard.devices"),
      icon: "plug",
      disabled: false,
    },
  ];

  // Traders and corporations own no production devices
  if (props.company && !IS_PRODUCER_VIEW[props.company.dashboard_view]) {
    return allTabs.filter((tab) => tab.id !== "devices");
  }

  return allTabs;
});

const { activeTab, setTab } = useTabs("settings-management", {
  defaultTabId: "settings",
  tabs: tabs.value,
});
</script>
